import actions from "./actions.js";
import mutations from "./mutations.js";

export const settingsModule = {
  state: {
    showSettingsEditor: false,
    numberOfVisibleFooterCommands: 9,
    redirectAfterSave: false,
    fileToEdit: null,
    customerId: null,
    redirectUrlAfterSave: null,
    callbackUrlAfterSave: null,
    showJacquardData: true,
    showColorControl: true,
    showShaftData: true,
    showDriveData: true,
    useHmt: false
  },
  namespaced: true,
  getters: {},
  actions,
  mutations
};
